import clsx from "clsx";
import React from "react";
import { CatalogItem, Media } from "types";
import { getXolaImageSize, Image, ImageSizes } from "./ProductImage";
import { getFormMediaUrl } from "@/hooks/formMediaUrl";
import { getDefaultPhotoUrl } from "@/models/CatalogItem";

export interface CatalogItemMediaImageProps {
    catalogItem: CatalogItem;
    media: Media;
    size?: keyof typeof ImageSizes;
    className?: string;
    classNames?: { image?: string; container?: string };
}

export const CatalogItemMediaImage = ({
    catalogItem,
    media,
    size = "medium",
    className,
    classNames,
    ...rest
}: CatalogItemMediaImageProps) => {
    const imageClassName = clsx(
        "border object-fill rounded",
        "!border-gray-light",
        ImageSizes[size],
        classNames?.image ?? "",
    );

    const xolaSize = getXolaImageSize(size);
    const mediaPath = `/catalogItems/${catalogItem.id}/medias/${media.id}?size=${xolaSize}`;
    const mediaSource = getFormMediaUrl(mediaPath);
    const imageSource = mediaSource || getDefaultPhotoUrl(catalogItem, xolaSize);

    return (
        <div
            className={clsx("ui-catalog-item-image mr-3 flex-shrink-0 rounded border-2 border-transparent", className)}
            {...rest}
        >
            <Image
                data-catalog-item-id={catalogItem?.id}
                src={imageSource}
                alt={catalogItem?.name?.trim() ?? "AddOn Image"}
                className={imageClassName}
            />
        </div>
    );
};
